import { __rest, __assign } from 'tslib';
import React from 'react';
import { IconRemove } from 'suomifi-icons';
import { Button } from '../../../../Button/Button.js';

var MultiSelectRemoveAllButton = function MultiSelectRemoveAllButton(props) {
  var className = props.className,
    selectedItems = props.selectedItems,
    children = props.children,
    onClick = props.onClick,
    passProps = __rest(props, ["className", "selectedItems", "children", "onClick"]);
  var selectedAndEnabledKeysCount = selectedItems.reduce(function (count, item) {
    if (item.disabled) {
      var newCount = count + 1;
      return newCount;
    }
    return count;
  }, 0);
  var showRemoveAllButton = children && Object.keys(selectedItems).length > 0 && Object.keys(selectedItems).length !== selectedAndEnabledKeysCount;
  return showRemoveAllButton ? ( /*#__PURE__*/React.createElement(Button, __assign({
    className: className,
    variant: "secondaryLight",
    icon: /*#__PURE__*/React.createElement(IconRemove, null),
    onClick: onClick
  }, passProps), children)) : null;
};

export { MultiSelectRemoveAllButton };
//# sourceMappingURL=MultiSelectRemoveAllButton.js.map
